'use es6';

import { Set as ImmutableSet } from 'immutable';
import * as dataTypes from '../constants/dataTypes';
import getProperties from '../properties/index';
const BLOCKLIST = {
  [dataTypes.CONTACTS]: ImmutableSet(['hs_count_is_worked', 'hs_count_is_unworked'])
};
const getBlocklist = dataType => BLOCKLIST[dataType] || ImmutableSet();
export let getBlocklistedForSearch = dataType => {
  return getProperties(dataType).then(properties => {
    const dataTypeProperties = properties.get(dataType);
    return dataTypeProperties.filter(property => property.get('scripted', false) || getBlocklist(dataType).includes(property.get('name'))).map(property => property.get('name')).toSet();
  });
};
export const setGetBlocklistedForSearchForTesting = mockedFunction => {
  getBlocklistedForSearch = mockedFunction;
};